module.exports = "<div *ngIf='isShown' class=\"has-error\">\r\n    <p class=\"help-block\">\r\n        {{ text }}\r\n    </p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/error/error.component.html
// module id = ../../../../../app/shared/components/easyForms/components/error/error.component.html
// module chunks = main